import React from 'react';
import { PropTypes } from 'prop-types';

const Button = ({ styles, type, disabled, children, as, onClick, value, id }) =>
    as !== 'input'
        ? React.createElement(as, { className: styles.button, disabled, type, onClick, id }, children)
        : React.createElement(as, { className: styles.button, disabled, type, value, id });

Button.propTypes = {
    styles: PropTypes.shape().isRequired,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Button.defaultProps = {
    as: 'button',
    type: 'button',
    disabled: false,
    children: null,
};

export default Button;
